/** Supabase email OTP length (currently 6 digits) */
export const OTP_LENGTH = 6;
